// layout
import MainLayout from "../Container/Layout/MainLayout";
// style
import styles from "../Styles/Order.module.css";
// component
import moment from "jalali-moment";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import Notfound from "../Components/Common/Notfound";
import QuoteImage from "../Components/Common/QuoteImage";
import { Context } from "../Context/Context";
import {
  Reordering,
  getOrder,
  getPaymentPageURL,
  sysAdminAddress,
} from "../Services/ContectService";

const Order = () => {
  const { json, user, loading, setLoading, provinceList } = useContext(Context);
  const content = json?.order;
  const navigate = useNavigate();

  const [tab, setTab] = useState("open");
  const [data, setData] = useState([]);
  const [dataOpen, setDataOpen] = useState([]);
  const [dataDone, setDataDone] = useState([]);
  const [dataCancel, setDataCancel] = useState([]);
  const [talkexpert, setTalkExpert] = useState("");

  const getOrderHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getOrder(user);
      if (status === 200) {
        setData(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const [sysAddress, setSysAddress] = useState(null);
  const getSysAdminAddressHandler = async () => {
    setLoading(true);
    try {
      const { status, data } = await sysAdminAddress(user);
      if (status === 200) {
        setSysAddress(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const reorderingrHandeler = async (id) => {
    setLoading(true);
    try {
      const { status } = await Reordering(user, id);
      if (status === 201) {
        toast.success(json.toast.Reordering);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const swalReorderingrHandeler = async (id) => {
    swal({
      title: json.swal.reorder.title,
      text: json.swal.reorder.text,
      icon: "warning",
      buttons: {
        cancel: json.swal.reorder.button_1,
        yes: json.swal.reorder.button_2,
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        reorderingrHandeler(id);
      }
    });
  };

  // const createOrderHandeler = async (item) => {
  //     setLoading(true);
  //     let newObject = {
  //         service_code: item.services.map(s => ({
  //             code: s.code
  //         })),
  //         delivery_type: item.delivery_type,
  //         is_custom_address: item.is_custom_address,
  //         custom_receiver_first_name: item.custom_receiver_first_name || "",
  //         custom_receiver_last_name: item.custom_receiver_last_name || "",
  //         custom_receiver_phone_number: item.custom_receiver_phone_number || item.user_detail.phone_number,
  //         custom_receiver_email: item.custom_receiver_email || "",
  //         custom_receiver_address_code: item.custom_receiver_address_code || "",
  //         custom_receiver_address: item.custom_receiver_address || item.user_detail.address,
  //         custom_receiver_national_code: item.custom_receiver_national_code || "",
  //         custom_receiver_province: item.custom_receiver_province || "",
  //         custom_receiver_city: item.custom_receiver_city || ""
  //     }
  //     try {
  //         const { status, data } = await createOrder(newObject, user);
  //         if (status === 200) {
  //             toast.success("سفارش شما ثبت شد");
  //             return navigate(`/Factors/${data}`)
  //         }
  //     } catch (error) {
  //         toast.error(json.toast.err_1);
  //     } finally {
  //         setLoading(false);
  //     }
  // }

  const goToPaymentPageHandler = async (installmentId, orderCode) => {
    setLoading(true);
    try {
      const response = await getPaymentPageURL(user, installmentId, orderCode);
      if (response.status === 200) {
        window.location.replace(response.data.url);
      } else {
        toast.error(json.toast.err_1);
        setLoading(false);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  // const showAnOrder = () => {
  //     setTimeout(() => {
  //         const el = document.querySelector(`[data-bs-target*="#panelsStayOpen-${data[data.length - 1].code}"]`)
  //         el.click();
  //     }, 5000);
  // }

  useEffect(() => {
    getOrderHandeler();
    getSysAdminAddressHandler();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      setDataOpen(data.filter((item) => item.status === "o"));
      setDataDone(data.filter((item) => item.status === "d"));
      setDataCancel(data.filter((item) => item.status === "c"));
      // showAnOrder();
    }
  }, [data]);

  return (
    <MainLayout>
      <div className={styles.orderTab}>
        <button
          className={tab === "open" ? styles.active : null}
          onClick={() => setTab("open")}
        >
          <p>{content.tab_1}</p>
          <div>{dataOpen.length}</div>
        </button>
        <button
          className={tab === "done" ? styles.active : null}
          onClick={() => setTab("done")}
        >
          <p>{content.tab_2}</p>
          <div>{dataDone.length}</div>
        </button>
        <button
          className={tab === "cancel" ? styles.active : null}
          onClick={() => setTab("cancel")}
        >
          <p>سفارشات لغو شده</p>
          <div>{dataCancel.length}</div>
        </button>
      </div>
      <section className={styles.order}>
        {tab === "open" &&
          (loading ? (
            <div className="d-flex justify-content-center px-2 py-5 h3">
              لطفاً صبر کنید...
            </div>
          ) : dataOpen.length > 0 ? (
            dataOpen.map((item, index) => (
              <div
                className="accordion-item main-accordion-item-order"
                key={`dataOpen_${index}`}
              >
                <div className="accordion-header collapsed">
                  <div className="flex items-center justify-between flex-wrap gap-3 w-full">
                    <p>
                      {content.ordercode}&nbsp;
                      {item.code}
                    </p>
                    <p>
                      {content.dateRegistration}&nbsp;
                      {moment(item.order_date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </p>
                    <p>
                      {content.discount}&nbsp;
                      {Number.isNaN(Number(item.discount_amount))
                        ? item.discount_amount
                        : `${Number(
                            item.discount_amount
                          ).toLocaleString()} تومان`}
                    </p>
                    <p>
                      {content.amount}&nbsp;
                      {Number.isNaN(Number(item.payment_price))
                        ? item.payment_price
                        : `${Number(
                            item.payment_price
                          ).toLocaleString()} تومان`}
                    </p>
                    <div className="d-flex flex-column">
                      <div className="d-flex gap-3">
                        <Link
                          to={`/PrintFactor/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {content.button_1}
                        </Link>
                        <button
                          className="main-btn main-btn-fill accordion-item-order-arrow"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#panelsStayOpen-${item.code}`}
                          aria-expanded="false"
                          aria-controls={`panelsStayOpen-${item.code}`}
                        >
                          {content.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id={`panelsStayOpen-${item.code}`}
                  className="accordion-collapse collapse"
                >
                  <div className="accordion-body flex flex-col gap-3">
                    <div className={styles.accordion_item_section}>
                      <p>
                        نحوه پرداخت:&nbsp;
                        {item.payment_type === "p"
                          ? "به صورت یکجا - پیش پرداخت (تخفیف بیشتر)"
                          : item.payment_type === "t"
                          ? "دو مرحله‌ای"
                          : item.payment_type === "c"
                          ? "پرداخت براساس قرارداد"
                          : ""}
                      </p>
                      <span className="align-left">
                        <button  
                          type="button"  
                          className="sm-main-btn sm-main-btn-fill align-left"  
                          onClick={() => {  
                            setTalkExpert(item.code);  
                            navigate(`/DetailsTicket/${item.ticket_code}`);  
                          }}  
                        >  
                          {content.talkexpert}  
                        </button> 
                      </span>
 

                        {item.order_installment.reverse().map((installment, index) => (
                        <div
                          key={`installment_${installment.id}`}
                          className="flex items-center justify-between flex-wrap my-1"
                        >
                          <div className="flex items-center flex-wrap gap-1 gap-md-3">
                            <p>فیش پرداخت {index + 1}</p>
                            <p>
                              تاریخ سر رسید:&nbsp;
                              {moment(installment.pay_date, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")}
                            </p>
                            <p>
                              مبلغ:&nbsp;
                              {Number.isNaN(Number(installment.amount))
                                ? installment.amount
                                : `${Number(
                                    installment.amount
                                  ).toLocaleString()} تومان`}
                            </p>
                          </div>
                          <button
                            type="submit"
                            className={`main-btn main-btn-fill px-12
                                                                    ${
                                                                      installment.is_paid
                                                                        ? "no-color bg-[#00FF5766] text-black pointer-events-none"
                                                                        : ""
                                                                    }`}
                            onClick={
                              installment.is_paid
                                ? () => {}
                                : () =>
                                    goToPaymentPageHandler(
                                      installment.id,
                                      item.code
                                    )
                            }
                          >
                            {installment.is_paid ? "پرداخت شده" : "پرداخت"}
                          </button>
                        </div>
                      ))}
                    </div>

                    {item.order_payment.filter((trans) => trans.is_paid)
                      .length > 0 && (
                      <div className={styles.accordion_item_section}>
                        <p>{content.item_1.title}</p>
                        {item.order_payment
                          .filter((trans) => trans.is_paid)
                          .map((transaction, index) => (
                            <div
                              key={`trans_${index}_${item.code}`}
                              className="flex items-center justify-between flex-wrap my-1"
                            >
                              <p>
                                فیش پرداخت{" "}
                                {item.order_installment.findIndex(
                                  (ins) => ins.id === transaction.installment
                                ) + 1}
                              </p>
                              <p>
                                تاریخ تراکنش:&nbsp;
                                {moment(transaction.transaction_date)
                                  .locale("fa")
                                  .format("YYYY/MM/DD")}
                              </p>
                              <p>
                                ساعت:&nbsp;
                                {moment(transaction.transaction_date)
                                  .locale("fa")
                                  .format("HH:mm")}
                              </p>
                              <p>
                                {content.item_1.issuetracking}&nbsp;
                                {transaction.trace_code}
                              </p>
                              <p>
                                {content.item_1.paymentamount}&nbsp;
                                {Number.isNaN(
                                  Number(
                                    item.order_installment.find(
                                      (ins) =>
                                        ins.id === transaction.installment
                                    )?.amount
                                  )
                                )
                                  ? item.order_installment.find(
                                      (ins) =>
                                        ins.id === transaction.installment
                                    )?.amount
                                  : Number(
                                      item.order_installment.find(
                                        (ins) =>
                                          ins.id === transaction.installment
                                      )?.amount
                                    ).toLocaleString()}
                              </p>
                            </div>
                          ))}
                      </div>
                    )}

                    <div className={styles.accordion_item_section}>
                      <p>
                        نحوه ارسال:&nbsp;
                        {item.delivery_type === "l"
                          ? "دریافت حضوری"
                          : item.delivery_type === "p"
                          ? "ارسال به آدرس شما"
                          : ""}
                      </p>
                      {item.delivery_type === "p" ? (
                        <div className="flex flex-col gap-3 p-4">
                          <div className="font-bold">
                            {content.item_2.address}&nbsp;
                            {`استان ${
                              provinceList.find(
                                (p) => p.state === item.address.province
                              )?.name
                            }، شهر ${item.address.city}، ${
                              item.address.physical_address
                            }`}
                          </div>
                          <div className="font-bold text-[#7F7F7F]">
                            {content.item_2.receiver}&nbsp;
                            {item.address.reciever_name}
                          </div>
                          <div className="font-bold text-[#7F7F7F]">
                            {content.item_2.Phonenumber}&nbsp;
                            {item.address.phone_number}
                          </div>
                          <div className="font-bold text-xl">
                            {content.item_2.shippingcost}&nbsp;
                            <span className="text-[#FF0000]">
                              {Number.isNaN(Number(item.transfer_price))
                                ? item.transfer_price
                                : `${Number(
                                    item.transfer_price
                                  ).toLocaleString()} تومان`}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col gap-2">
                          <div className="font-bold">
                            {" "}
                            {`استان ${
                                provinceList.find(
                                  (p) => p.state === sysAddress?.province
                                )?.name
                              }، شهر ${sysAddress?.city}، ${
                                sysAddress?.address
                            }`}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            {sysAddress?.reciever_name}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            شماره تماس: {sysAddress?.phone_number}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles.accordion_item_section}>
                      <p>{content.item_3.title}</p>
                      {item.services.map((service, index) => (
                        <div key={`service_${index}`} className="w-full my-1">
                          <div
                            key={index}
                            className="w-full flex justify-between"
                          >
                            <div className="flex-1 flex flex-col justify-evenly">
                              <p>
                                {content.item_3.producttype}&nbsp; ماشینکاری CNC
                              </p>
                              {/* 
                                                                    <p>
                                                                        {content.item_3.datepreparation}
                                                                        {item.date_calculation ? moment(item.date_calculation, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : null}
                                                                    </p> 
                                                                    */}
                              <p>
                                {content.item_3.number}&nbsp;
                                {service.quantity}
                              </p>
                              {item.is_paid ? (
                                <p>
                                  تاریخ آماده سازی :&nbsp;
                                  {service.preparation_date
                                    ? moment(
                                        service.preparation_date,
                                        "YYYY/MM/DD"
                                      )
                                        .locale("fa")
                                        .format("YYYY/MM/DD")
                                    : "مشخص نشده"}
                                </p>
                              ) : null}
                              <p>
                                {content.item_3.unitprice}&nbsp;
                                {Number.isNaN(Number(service.unit_price))
                                  ? service.unit_price
                                  : `${Number(
                                      service.unit_price
                                    ).toLocaleString()} تومان`}
                              </p>
                              <p className="text-xl">
                                قیمت کل: &nbsp;
                                <span className="text-[#FF0000]">
                                  {Number.isNaN(Number(service.total_price))
                                    ? service.total_price
                                    : `${Number(
                                        service.total_price
                                      ).toLocaleString()} تومان`}
                                </span>
                              </p>
                            </div>
                            <div className="flex-1 flex flex-col items-end justify-between gap-8 p-4">
                              <div className={styles.accordion_item_img}>
                                {service.image ? (
                                  <QuoteImage code={service.code} />
                                ) : (
                                  <img
                                    src="/imgs/upload/wisercam image.png"
                                    alt="Wisercam"
                                  />
                                )}
                              </div>
                              <div className="flex items-center justify-between gap-2">
                                {/* <button
                                  className="main-btn main-btn-fill 
                                                                        no-color bg-[#D9D9D9] text-black"
                                  onClick={() =>
                                    swalReorderingrHandeler(service.code)
                                  }
                                >
                                  {content.item_3.button_1}
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M30.499 6.99998V13C30.499 13.3978 30.341 13.7793 30.0596 14.0606C29.7783 14.3419 29.3968 14.5 28.999 14.5H22.999C22.6012 14.5 22.2196 14.3419 21.9383 14.0606C21.657 13.7793 21.499 13.3978 21.499 13C21.499 12.6022 21.657 12.2206 21.9383 11.9393C22.2196 11.658 22.6012 11.5 22.999 11.5H25.1365L22.7615 9.32748C22.7452 9.31248 22.729 9.29748 22.714 9.28123C21.6128 8.18068 20.2579 7.36764 18.7687 6.91365C17.2795 6.45967 15.7015 6.37865 14.1736 6.67773C12.6457 6.97681 11.2147 7.64682 10.0066 8.6288C8.79841 9.61079 7.85012 10.8747 7.24512 12.3092C6.64013 13.7437 6.39697 15.305 6.53705 16.8555C6.67713 18.4061 7.19616 19.8985 8.04845 21.2014C8.90074 22.5043 10.0602 23.5777 11.4248 24.3273C12.7893 25.0769 14.3172 25.4796 15.874 25.5H15.999C18.4239 25.5058 20.7581 24.5784 22.5177 22.91C22.807 22.6366 23.193 22.4894 23.5908 22.5007C23.9886 22.5119 24.3656 22.6807 24.639 22.97C24.9123 23.2592 25.0596 23.6452 25.0483 24.043C25.0371 24.4408 24.8682 24.8179 24.579 25.0912C22.2626 27.2867 19.1905 28.5073 15.999 28.5H15.8277C13.7815 28.4711 11.7737 27.9404 9.98059 26.9543C8.18745 25.9682 6.66382 24.557 5.54351 22.8445C4.42319 21.132 3.74044 19.1706 3.55522 17.1326C3.36999 15.0946 3.68796 13.0423 4.48118 11.1559C5.27441 9.26953 6.51865 7.60673 8.10463 6.31352C9.69062 5.02032 11.5699 4.13628 13.5773 3.73902C15.5848 3.34176 17.6591 3.44343 19.6181 4.03511C21.5771 4.62679 23.3608 5.69037 24.8127 7.13248L27.499 9.58998V6.99998C27.499 6.60216 27.657 6.22062 27.9383 5.93932C28.2196 5.65802 28.6012 5.49998 28.999 5.49998C29.3968 5.49998 29.7783 5.65802 30.0596 5.93932C30.341 6.22062 30.499 6.60216 30.499 6.99998Z"
                                      fill="black"
                                    />
                                  </svg>
                                </button> */}
                                <button
                                  onClick={() =>
                                    navigate(`/DetailOrder/${service.code}`)
                                  }
                                  className="main-btn main-btn-fill"
                                >
                                  {content.item_3.button_2}
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                                      fill="white"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Notfound />
          ))}

        {tab === "done" &&
          (loading ? (
            <div className="d-flex justify-content-center px-2 py-5 h3">
              لطفاً صبر کنید...
            </div>
          ) : dataDone.length > 0 ? (
            dataDone.map((item, index) => (
              <div
                className="accordion-item main-accordion-item-order"
                key={index}
              >
                <div className="accordion-header collapsed">
                  <div className="flex items-center justify-between flex-wrap gap-3 w-full">
                    <p>
                      {content.ordercode}&nbsp;
                      {item.code}
                    </p>
                    <p>
                      {content.dateRegistration}&nbsp;
                      {moment(item.order_date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </p>
                    <p>
                      {content.discount}&nbsp;
                      {Number.isNaN(Number(item.discount_amount))
                        ? item.discount_amount
                        : `${Number(
                            item.discount_amount
                          ).toLocaleString()} تومان`}
                    </p>
                    <p>
                      {content.amount}&nbsp;
                      {Number.isNaN(Number(item.payment_price))
                        ? item.payment_price
                        : `${Number(
                            item.payment_price
                          ).toLocaleString()} تومان`}
                    </p>
                    <div className="d-flex flex-column">
                      <div className="d-flex gap-3">
                        <Link
                          to={`/PrintFactor/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {content.button_1}
                        </Link>
                        <button
                          className="main-btn main-btn-fill accordion-item-order-arrow"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#panelsStayOpen-${item.code}`}
                          aria-expanded="false"
                          aria-controls={`panelsStayOpen-${item.code}`}
                        >
                          {content.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id={`panelsStayOpen-${item.code}`}
                  className="accordion-collapse collapse"
                >
                  <div className="accordion-body flex flex-col gap-3">
                    <div className={styles.accordion_item_section}>
                      <p>
                        نحوه پرداخت:&nbsp;
                        {item.payment_type === "p"
                          ? "به صورت یکجا - پیش پرداخت (تخفیف بیشتر)"
                          : item.payment_type === "t"
                          ? "دو مرحله‌ای"
                          : item.payment_type === "c"
                          ? "پرداخت براساس قرارداد"
                          : ""}
                      </p>
                      {item.order_installment.map((installment, index) => (
                        <div
                          key={`installment_${installment.id}`}
                          className="flex items-center justify-between flex-wrap my-1"
                        >
                          <div className="flex items-center flex-wrap gap-1 gap-md-3">
                            <p>فیش پرداخت {index + 1}</p>
                            <p>
                              تاریخ سر رسید:&nbsp;
                              {moment(installment.pay_date, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")}
                            </p>
                            <p>
                              مبلغ:&nbsp;
                              {Number.isNaN(Number(installment.amount))
                                ? installment.amount
                                : `${Number(
                                    installment.amount
                                  ).toLocaleString()} تومان`}
                            </p>
                          </div>
                          <button
                            type="submit"
                            className={`main-btn main-btn-fill px-12
                                                                    ${
                                                                      installment.is_paid
                                                                        ? "no-color bg-[#00FF5766] text-black pointer-events-none"
                                                                        : ""
                                                                    }`}
                            onClick={
                              installment.is_paid
                                ? () => {}
                                : () =>
                                    goToPaymentPageHandler(
                                      installment.id,
                                      item.code
                                    )
                            }
                          >
                            {installment.is_paid ? "پرداخت شده" : "پرداخت"}
                          </button>
                        </div>
                      ))}
                    </div>

                    {item.order_payment.filter((trans) => trans.is_paid)
                      .length > 0 && (
                      <div className={styles.accordion_item_section}>
                        <p>{content.item_1.title}</p>
                        {item.order_payment
                          .filter((trans) => trans.is_paid)
                          .map((transaction, index) => (
                            <div
                              key={`trans_${index}_${item.code}`}
                              className="flex items-center justify-between flex-wrap my-1"
                            >
                              <p>
                                فیش پرداخت{" "}
                                {item.order_installment.findIndex(
                                  (ins) => ins.id === transaction.installment
                                ) + 1}
                              </p>
                              <p>
                                تاریخ تراکنش:&nbsp;
                                {moment(transaction.transaction_date)
                                  .locale("fa")
                                  .format("YYYY/MM/DD")}
                              </p>
                              <p>
                                ساعت:&nbsp;
                                {moment(transaction.transaction_date)
                                  .locale("fa")
                                  .format("HH:mm")}
                              </p>
                              <p>
                                {content.item_1.issuetracking}&nbsp;
                                {transaction.trace_code}
                              </p>
                              <p>
                                {content.item_1.paymentamount}&nbsp;
                                {Number.isNaN(
                                  Number(
                                    item.order_installment.find(
                                      (ins) =>
                                        ins.id === transaction.installment
                                    )?.amount
                                  )
                                )
                                  ? item.order_installment.find(
                                      (ins) =>
                                        ins.id === transaction.installment
                                    )?.amount
                                  : Number(
                                      item.order_installment.find(
                                        (ins) =>
                                          ins.id === transaction.installment
                                      )?.amount
                                    ).toLocaleString()}
                              </p>
                            </div>
                          ))}
                      </div>
                    )}

                    <div className={styles.accordion_item_section}>
                      <p>
                        نحوه ارسال:&nbsp;
                        {item.delivery_type === "l"
                          ? "دریافت حضوری"
                          : item.delivery_type === "p"
                          ? "ارسال به آدرس شما"
                          : ""}
                      </p>
                      {item.delivery_type === "p" ? (
                        <div className="flex flex-col gap-3 p-4">
                          <div className="font-bold">
                            {content.item_2.address}&nbsp;
                            {`استان ${
                              provinceList.find(
                                (p) => p.state === item.address.province
                              )?.name
                            }، شهر ${item.address.city}، ${
                              item.address.physical_address
                            }`}
                          </div>
                          <div className="font-bold text-[#7F7F7F]">
                            {content.item_2.receiver}&nbsp;
                            {item.address.reciever_name}
                          </div>
                          <div className="font-bold text-[#7F7F7F]">
                            {content.item_2.Phonenumber}&nbsp;
                            {item.address.phone_number}
                          </div>
                          <div className="font-bold text-xl">
                            {content.item_2.shippingcost}&nbsp;
                            <span className="text-[#FF0000]">
                              {Number.isNaN(Number(item.transfer_price))
                                ? item.transfer_price
                                : `${Number(
                                    item.transfer_price
                                  ).toLocaleString()} تومان`}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col gap-2">
                          <div className="font-bold">
                            {" "}
                            {`استان ${
                                provinceList.find(
                                  (p) => p.state === sysAddress?.province
                                )?.name
                              }، شهر ${sysAddress?.city}، ${
                                sysAddress?.address
                            }`}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            {sysAddress?.reciever_name}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            شماره تماس: {sysAddress?.phone_number}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles.accordion_item_section}>
                      <p>{content.item_3.title}</p>
                      {item.services.map((service, index) => (
                        <div className="w-full my-1">
                          <div
                            key={index}
                            className="w-full flex justify-between"
                          >
                            <div className="flex-1 flex flex-col justify-evenly">
                              <p>
                                {content.item_3.producttype}&nbsp; ماشینکاری CNC
                              </p>
                              {/* 
                                                                    <p>
                                                                        {content.item_3.datepreparation}
                                                                        {item.date_calculation ? moment(item.date_calculation, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : null}
                                                                    </p> 
                                                                    */}
                              <p>
                                {content.item_3.number}&nbsp;
                                {service.quantity}
                              </p>
                              <p>
                                {content.item_3.unitprice}&nbsp;
                                {Number.isNaN(Number(service.unit_price))
                                  ? service.unit_price
                                  : `${Number(
                                      service.unit_price
                                    ).toLocaleString()} تومان`}
                              </p>
                              <p className="text-xl">
                                قیمت کل: &nbsp;
                                <span className="text-[#FF0000]">
                                  {Number.isNaN(Number(service.total_price))
                                    ? service.total_price
                                    : `${Number(
                                        service.total_price
                                      ).toLocaleString()} تومان`}
                                </span>
                              </p>
                            </div>
                            <div className="flex-1 flex flex-col items-end justify-between gap-8 p-4">
                              <div className={styles.accordion_item_img}>
                                {service.image ? (
                                  <QuoteImage code={service.code} />
                                ) : (
                                  <img
                                    src="/imgs/upload/wisercam image.png"
                                    alt="Wisercam"
                                  />
                                )}
                              </div>
                              <div className="flex items-center justify-between gap-2">
                                <button
                                  className="main-btn main-btn-fill 
                                                                        no-color bg-[#D9D9D9] text-black"
                                  onClick={() =>
                                    swalReorderingrHandeler(service.code)
                                  }
                                >
                                  {content.item_3.button_1}
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M30.499 6.99998V13C30.499 13.3978 30.341 13.7793 30.0596 14.0606C29.7783 14.3419 29.3968 14.5 28.999 14.5H22.999C22.6012 14.5 22.2196 14.3419 21.9383 14.0606C21.657 13.7793 21.499 13.3978 21.499 13C21.499 12.6022 21.657 12.2206 21.9383 11.9393C22.2196 11.658 22.6012 11.5 22.999 11.5H25.1365L22.7615 9.32748C22.7452 9.31248 22.729 9.29748 22.714 9.28123C21.6128 8.18068 20.2579 7.36764 18.7687 6.91365C17.2795 6.45967 15.7015 6.37865 14.1736 6.67773C12.6457 6.97681 11.2147 7.64682 10.0066 8.6288C8.79841 9.61079 7.85012 10.8747 7.24512 12.3092C6.64013 13.7437 6.39697 15.305 6.53705 16.8555C6.67713 18.4061 7.19616 19.8985 8.04845 21.2014C8.90074 22.5043 10.0602 23.5777 11.4248 24.3273C12.7893 25.0769 14.3172 25.4796 15.874 25.5H15.999C18.4239 25.5058 20.7581 24.5784 22.5177 22.91C22.807 22.6366 23.193 22.4894 23.5908 22.5007C23.9886 22.5119 24.3656 22.6807 24.639 22.97C24.9123 23.2592 25.0596 23.6452 25.0483 24.043C25.0371 24.4408 24.8682 24.8179 24.579 25.0912C22.2626 27.2867 19.1905 28.5073 15.999 28.5H15.8277C13.7815 28.4711 11.7737 27.9404 9.98059 26.9543C8.18745 25.9682 6.66382 24.557 5.54351 22.8445C4.42319 21.132 3.74044 19.1706 3.55522 17.1326C3.36999 15.0946 3.68796 13.0423 4.48118 11.1559C5.27441 9.26953 6.51865 7.60673 8.10463 6.31352C9.69062 5.02032 11.5699 4.13628 13.5773 3.73902C15.5848 3.34176 17.6591 3.44343 19.6181 4.03511C21.5771 4.62679 23.3608 5.69037 24.8127 7.13248L27.499 9.58998V6.99998C27.499 6.60216 27.657 6.22062 27.9383 5.93932C28.2196 5.65802 28.6012 5.49998 28.999 5.49998C29.3968 5.49998 29.7783 5.65802 30.0596 5.93932C30.341 6.22062 30.499 6.60216 30.499 6.99998Z"
                                      fill="black"
                                    />
                                  </svg>
                                </button>
                                <button
                                  onClick={() =>
                                    navigate(`/DetailOrder/${service.code}`)
                                  }
                                  className="main-btn main-btn-fill"
                                >
                                  {content.item_3.button_2}
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                                      fill="white"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Notfound />
          ))}

        {tab === "cancel" &&
          (loading ? (
            <div className="d-flex justify-content-center px-2 py-5 h3">
              لطفاً صبر کنید...
            </div>
          ) : dataCancel.length > 0 ? (
            dataCancel.map((item, index) => (
              <div
                className="accordion-item main-accordion-item-order"
                key={index}
              >
                <div className="accordion-header collapsed">
                  <div className="flex items-center justify-between flex-wrap gap-3 w-full">
                    <p>
                      {content.ordercode}&nbsp;
                      {item.code}
                    </p>
                    <p>
                      {content.dateRegistration}&nbsp;
                      {moment(item.order_date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </p>
                    <p>
                      {content.discount}&nbsp;
                      {Number.isNaN(Number(item.discount_amount))
                        ? item.discount_amount
                        : `${Number(
                            item.discount_amount
                          ).toLocaleString()} تومان`}
                    </p>
                    <p>
                      {content.amount}&nbsp;
                      {Number.isNaN(Number(item.payment_price))
                        ? item.payment_price
                        : `${Number(
                            item.payment_price
                          ).toLocaleString()} تومان`}
                    </p>
                    <div className="d-flex flex-column">
                      <div className="d-flex gap-3">
                        <Link
                          to={`/PrintFactor/${item.code}`}
                          className="main-btn main-btn-fill"
                        >
                          {content.button_1}
                        </Link>
                        <button
                          className="main-btn main-btn-fill accordion-item-order-arrow"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#panelsStayOpen-${item.code}`}
                          aria-expanded="false"
                          aria-controls={`panelsStayOpen-${item.code}`}
                        >
                          {content.button_2}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id={`panelsStayOpen-${item.code}`}
                  className="accordion-collapse collapse"
                >
                  <div className="accordion-body flex flex-col gap-3">
                    <div className={styles.accordion_item_section}>
                      <p>
                        نحوه پرداخت:&nbsp;
                        {item.payment_type === "p"
                          ? "به صورت یکجا - پیش پرداخت (تخفیف بیشتر)"
                          : item.payment_type === "t"
                          ? "دو مرحله‌ای"
                          : item.payment_type === "c"
                          ? "پرداخت براساس قرارداد"
                          : ""}
                      </p>
                      {item.order_installment.map((installment, index) => (
                        <div
                          key={`installment_${installment.id}`}
                          className="flex items-center justify-between flex-wrap my-1"
                        >
                          <div className="flex items-center flex-wrap gap-1 gap-md-3">
                            <p>فیش پرداخت {index + 1}</p>
                            <p>
                              تاریخ سر رسید:&nbsp;
                              {moment(installment.pay_date, "YYYY/MM/DD")
                                .locale("fa")
                                .format("YYYY/MM/DD")}
                            </p>
                            <p>
                              مبلغ:&nbsp;
                              {Number.isNaN(Number(installment.amount))
                                ? installment.amount
                                : `${Number(
                                    installment.amount
                                  ).toLocaleString()} تومان`}
                            </p>
                          </div>
                          <button
                            type="submit"
                            className={`main-btn main-btn-fill px-12 pointer-events-none
                                                                    ${
                                                                      installment.is_paid
                                                                        ? "no-color bg-[#00FF5766] text-black"
                                                                        : ""
                                                                    }`}
                            onClick={
                              installment.is_paid
                                ? () => {}
                                : () =>
                                    goToPaymentPageHandler(
                                      installment.id,
                                      item.code
                                    )
                            }
                          >
                            {installment.is_paid ? "پرداخت شده" : "پرداخت"}
                          </button>
                        </div>
                      ))}
                    </div>

                    {item.order_payment.filter((trans) => trans.is_paid)
                      .length > 0 && (
                      <div className={styles.accordion_item_section}>
                        <p>{content.item_1.title}</p>
                        {item.order_payment
                          .filter((trans) => trans.is_paid)
                          .map((transaction, index) => (
                            <div
                              key={`trans_${index}_${item.code}`}
                              className="flex items-center justify-between flex-wrap my-1"
                            >
                              <p>
                                فیش پرداخت{" "}
                                {item.order_installment.findIndex(
                                  (ins) => ins.id === transaction.installment
                                ) + 1}
                              </p>
                              <p>
                                تاریخ تراکنش:&nbsp;
                                {moment(transaction.transaction_date)
                                  .locale("fa")
                                  .format("YYYY/MM/DD")}
                              </p>
                              <p>
                                ساعت:&nbsp;
                                {moment(transaction.transaction_date)
                                  .locale("fa")
                                  .format("HH:mm")}
                              </p>
                              <p>
                                {content.item_1.issuetracking}&nbsp;
                                {transaction.trace_code}
                              </p>
                              <p>
                                {content.item_1.paymentamount}&nbsp;
                                {Number.isNaN(
                                  Number(
                                    item.order_installment.find(
                                      (ins) =>
                                        ins.id === transaction.installment
                                    )?.amount
                                  )
                                )
                                  ? item.order_installment.find(
                                      (ins) =>
                                        ins.id === transaction.installment
                                    )?.amount
                                  : Number(
                                      item.order_installment.find(
                                        (ins) =>
                                          ins.id === transaction.installment
                                      )?.amount
                                    ).toLocaleString()}
                              </p>
                            </div>
                          ))}
                      </div>
                    )}

                    <div className={styles.accordion_item_section}>
                      <p>
                        نحوه ارسال:&nbsp;
                        {item.delivery_type === "l"
                          ? "دریافت حضوری"
                          : item.delivery_type === "p"
                          ? "ارسال به آدرس شما"
                          : ""}
                      </p>
                      {item.delivery_type === "p" ? (
                        <div className="flex flex-col gap-3 p-4">
                          <div className="font-bold">
                            {content.item_2.address}&nbsp;
                            {`استان ${
                              provinceList.find(
                                (p) => p.state === item.address.province
                              )?.name
                            }، شهر ${item.address.city}، ${
                              item.address.physical_address
                            }`}
                          </div>
                          <div className="font-bold text-[#7F7F7F]">
                            {content.item_2.receiver}&nbsp;
                            {item.address.reciever_name}
                          </div>
                          <div className="font-bold text-[#7F7F7F]">
                            {content.item_2.Phonenumber}&nbsp;
                            {item.address.phone_number}
                          </div>
                          <div className="font-bold text-xl">
                            {content.item_2.shippingcost}&nbsp;
                            <span className="text-[#FF0000]">
                              {Number.isNaN(Number(item.transfer_price))
                                ? item.transfer_price
                                : `${Number(
                                    item.transfer_price
                                  ).toLocaleString()} تومان`}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col gap-2">
                          <div className="font-bold">
                            {" "}
                            {`استان ${
                                provinceList.find(
                                  (p) => p.state === sysAddress?.province
                                )?.name
                              }، شهر ${sysAddress?.city}، ${
                                sysAddress?.address
                            }`}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            {sysAddress?.reciever_name}
                          </div>
                          <div className="text-[#7F7F7F] font-bold">
                            شماره تماس: {sysAddress?.phone_number}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles.accordion_item_section}>
                      <p>{content.item_3.title}</p>
                      {item.services.map((service, index) => (
                        <div className="w-full my-1">
                          <div
                            key={index}
                            className="w-full flex justify-between"
                          >
                            <div className="flex-1 flex flex-col justify-evenly">
                              <p>
                                {content.item_3.producttype}&nbsp; ماشینکاری CNC
                              </p>
                              {/* 
                                                                    <p>
                                                                        {content.item_3.datepreparation}
                                                                        {item.date_calculation ? moment(item.date_calculation, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : null}
                                                                    </p> 
                                                                    */}
                              <p>
                                {content.item_3.number}&nbsp;
                                {service.quantity}
                              </p>
                              <p>
                                {content.item_3.unitprice}&nbsp;
                                {Number.isNaN(Number(service.unit_price))
                                  ? service.unit_price
                                  : `${Number(
                                      service.unit_price
                                    ).toLocaleString()} تومان`}
                              </p>
                              <p className="text-xl">
                                قیمت کل: &nbsp;
                                <span className="text-[#FF0000]">
                                  {Number.isNaN(Number(service.total_price))
                                    ? service.total_price
                                    : `${Number(
                                        service.total_price
                                      ).toLocaleString()} تومان`}
                                </span>
                              </p>
                            </div>
                            <div className="flex-1 flex flex-col items-end justify-between gap-8 p-4">
                              <div className={styles.accordion_item_img}>
                                {service.image ? (
                                  <QuoteImage code={service.code} />
                                ) : (
                                  <img
                                    src="/imgs/upload/wisercam image.png"
                                    alt="Wisercam"
                                  />
                                )}
                              </div>
                              <div className="flex items-center justify-between gap-2">
                                <button
                                  className="main-btn main-btn-fill 
                                                                        no-color bg-[#D9D9D9] text-black"
                                  onClick={() =>
                                    swalReorderingrHandeler(service.code)
                                  }
                                >
                                  {content.item_3.button_1}
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M30.499 6.99998V13C30.499 13.3978 30.341 13.7793 30.0596 14.0606C29.7783 14.3419 29.3968 14.5 28.999 14.5H22.999C22.6012 14.5 22.2196 14.3419 21.9383 14.0606C21.657 13.7793 21.499 13.3978 21.499 13C21.499 12.6022 21.657 12.2206 21.9383 11.9393C22.2196 11.658 22.6012 11.5 22.999 11.5H25.1365L22.7615 9.32748C22.7452 9.31248 22.729 9.29748 22.714 9.28123C21.6128 8.18068 20.2579 7.36764 18.7687 6.91365C17.2795 6.45967 15.7015 6.37865 14.1736 6.67773C12.6457 6.97681 11.2147 7.64682 10.0066 8.6288C8.79841 9.61079 7.85012 10.8747 7.24512 12.3092C6.64013 13.7437 6.39697 15.305 6.53705 16.8555C6.67713 18.4061 7.19616 19.8985 8.04845 21.2014C8.90074 22.5043 10.0602 23.5777 11.4248 24.3273C12.7893 25.0769 14.3172 25.4796 15.874 25.5H15.999C18.4239 25.5058 20.7581 24.5784 22.5177 22.91C22.807 22.6366 23.193 22.4894 23.5908 22.5007C23.9886 22.5119 24.3656 22.6807 24.639 22.97C24.9123 23.2592 25.0596 23.6452 25.0483 24.043C25.0371 24.4408 24.8682 24.8179 24.579 25.0912C22.2626 27.2867 19.1905 28.5073 15.999 28.5H15.8277C13.7815 28.4711 11.7737 27.9404 9.98059 26.9543C8.18745 25.9682 6.66382 24.557 5.54351 22.8445C4.42319 21.132 3.74044 19.1706 3.55522 17.1326C3.36999 15.0946 3.68796 13.0423 4.48118 11.1559C5.27441 9.26953 6.51865 7.60673 8.10463 6.31352C9.69062 5.02032 11.5699 4.13628 13.5773 3.73902C15.5848 3.34176 17.6591 3.44343 19.6181 4.03511C21.5771 4.62679 23.3608 5.69037 24.8127 7.13248L27.499 9.58998V6.99998C27.499 6.60216 27.657 6.22062 27.9383 5.93932C28.2196 5.65802 28.6012 5.49998 28.999 5.49998C29.3968 5.49998 29.7783 5.65802 30.0596 5.93932C30.341 6.22062 30.499 6.60216 30.499 6.99998Z"
                                      fill="black"
                                    />
                                  </svg>
                                </button>
                                <button
                                  onClick={() =>
                                    navigate(`/DetailOrder/${service.code}`)
                                  }
                                  className="main-btn main-btn-fill"
                                >
                                  {content.item_3.button_2}
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.4996 12.7575V5C8.4996 4.60218 8.34157 4.22064 8.06026 3.93934C7.77896 3.65804 7.39743 3.5 6.9996 3.5C6.60178 3.5 6.22025 3.65804 5.93894 3.93934C5.65764 4.22064 5.4996 4.60218 5.4996 5V12.7575C4.62234 13.0677 3.86283 13.6423 3.32564 14.4021C2.78845 15.1619 2.5 16.0695 2.5 17C2.5 17.9305 2.78845 18.8381 3.32564 19.5979C3.86283 20.3577 4.62234 20.9323 5.4996 21.2425V27C5.4996 27.3978 5.65764 27.7794 5.93894 28.0607C6.22025 28.342 6.60178 28.5 6.9996 28.5C7.39743 28.5 7.77896 28.342 8.06026 28.0607C8.34157 27.7794 8.4996 27.3978 8.4996 27V21.2425C9.37686 20.9323 10.1364 20.3577 10.6736 19.5979C11.2108 18.8381 11.4992 17.9305 11.4992 17C11.4992 16.0695 11.2108 15.1619 10.6736 14.4021C10.1364 13.6423 9.37686 13.0677 8.4996 12.7575ZM6.9996 18.5C6.70293 18.5 6.41292 18.412 6.16625 18.2472C5.91957 18.0824 5.72731 17.8481 5.61378 17.574C5.50025 17.2999 5.47055 16.9983 5.52842 16.7074C5.5863 16.4164 5.72916 16.1491 5.93894 15.9393C6.14872 15.7296 6.41599 15.5867 6.70697 15.5288C6.99794 15.4709 7.29954 15.5006 7.57363 15.6142C7.84772 15.7277 8.08198 15.92 8.24681 16.1666C8.41163 16.4133 8.4996 16.7033 8.4996 17C8.4996 17.3978 8.34157 17.7794 8.06026 18.0607C7.77896 18.342 7.39743 18.5 6.9996 18.5ZM20.4996 11C20.4983 10.0698 20.2093 9.16268 19.6722 8.40314C19.1351 7.6436 18.3762 7.06879 17.4996 6.7575V5C17.4996 4.60218 17.3416 4.22064 17.0603 3.93934C16.779 3.65804 16.3974 3.5 15.9996 3.5C15.6018 3.5 15.2202 3.65804 14.9389 3.93934C14.6576 4.22064 14.4996 4.60218 14.4996 5V6.7575C13.6223 7.06775 12.8628 7.64232 12.3256 8.4021C11.7885 9.16187 11.5 10.0695 11.5 11C11.5 11.9305 11.7885 12.8381 12.3256 13.5979C12.8628 14.3577 13.6223 14.9323 14.4996 15.2425V27C14.4996 27.3978 14.6576 27.7794 14.9389 28.0607C15.2202 28.342 15.6018 28.5 15.9996 28.5C16.3974 28.5 16.779 28.342 17.0603 28.0607C17.3416 27.7794 17.4996 27.3978 17.4996 27V15.2425C18.3762 14.9312 19.1351 14.3564 19.6722 13.5969C20.2093 12.8373 20.4983 11.9302 20.4996 11ZM15.9996 12.5C15.7029 12.5 15.4129 12.412 15.1662 12.2472C14.9196 12.0824 14.7273 11.8481 14.6138 11.574C14.5003 11.2999 14.4705 10.9983 14.5284 10.7074C14.5863 10.4164 14.7292 10.1491 14.9389 9.93934C15.1487 9.72956 15.416 9.5867 15.707 9.52882C15.9979 9.47094 16.2995 9.50065 16.5736 9.61418C16.8477 9.72771 17.082 9.91997 17.2468 10.1666C17.4116 10.4133 17.4996 10.7033 17.4996 11C17.4996 11.3978 17.3416 11.7794 17.0603 12.0607C16.779 12.342 16.3974 12.5 15.9996 12.5ZM29.4996 21C29.4983 20.0698 29.2093 19.1627 28.6722 18.4031C28.1351 17.6436 27.3762 17.0688 26.4996 16.7575V5C26.4996 4.60218 26.3416 4.22064 26.0603 3.93934C25.779 3.65804 25.3974 3.5 24.9996 3.5C24.6018 3.5 24.2202 3.65804 23.9389 3.93934C23.6576 4.22064 23.4996 4.60218 23.4996 5V16.7575C22.6223 17.0677 21.8628 17.6423 21.3256 18.4021C20.7885 19.1619 20.5 20.0695 20.5 21C20.5 21.9305 20.7885 22.8381 21.3256 23.5979C21.8628 24.3577 22.6223 24.9323 23.4996 25.2425V27C23.4996 27.3978 23.6576 27.7794 23.9389 28.0607C24.2202 28.342 24.6018 28.5 24.9996 28.5C25.3974 28.5 25.779 28.342 26.0603 28.0607C26.3416 27.7794 26.4996 27.3978 26.4996 27V25.2425C27.3762 24.9312 28.1351 24.3564 28.6722 23.5969C29.2093 22.8373 29.4983 21.9302 29.4996 21ZM24.9996 22.5C24.7029 22.5 24.4129 22.412 24.1662 22.2472C23.9196 22.0824 23.7273 21.8481 23.6138 21.574C23.5003 21.2999 23.4705 20.9983 23.5284 20.7074C23.5863 20.4164 23.7292 20.1491 23.9389 19.9393C24.1487 19.7296 24.416 19.5867 24.707 19.5288C24.9979 19.4709 25.2995 19.5007 25.5736 19.6142C25.8477 19.7277 26.082 19.92 26.2468 20.1666C26.4116 20.4133 26.4996 20.7033 26.4996 21C26.4996 21.3978 26.3416 21.7794 26.0603 22.0607C25.779 22.342 25.3974 22.5 24.9996 22.5Z"
                                      fill="white"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Notfound />
          ))}
      </section>
    </MainLayout>
  );
};

export default Order;
